import React from 'react';
import { FaTimes } from 'react-icons/fa';

const DateFilterModal = ({ isOpen, onClose, startDate, setStartDate, endDate, setEndDate, onApply }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    onClose();
  };

  const handleModalClick = (e) => {
    e.stopPropagation(); 
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content" onClick={handleModalClick}>
        <h5>Applied Date</h5>
        <div className="date-filter-modal">
          <label>From: </label>
          <div className="input-with-clear">
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            {startDate && (
              <FaTimes
                className="clear-icon"
                onClick={() => setStartDate('')}
              />
            )}
          </div>

          <label>To: </label>
          <div className="input-with-clear">
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
            {endDate && (
              <FaTimes
                className="clear-icon"
                onClick={() => setEndDate('')}
              />
            )}
          </div>
        </div>

        <div className="modal-actions">
          <button onClick={onClose}>Apply</button>
        </div>
      </div>
    </div>
  );
};

export default DateFilterModal;
